export const SYSTEM_WEB = "web player";
export const SYSTEM_WEBOS = "webos";
export const SYSTEM_TIZEN = "tizen";
